import { useTranslation } from "react-i18next";
import { useRoutes } from "react-router-dom";

import SoftaveraTransactionsEcomOverview from "@pages/AdvancedReporting/SoftaveraTransactionsEcomOverview";
import SoftaveraTransactionsOverview from "@pages/AdvancedReporting/SoftaveraTransactionsOverview";
import AdyenTransactionsOverview from "@pages/Reporting/AdyenTransactionsOverview";
import PaiementsConecsOverview from "@pages/connecs/PaiementsConecsOverview";
import AdyenPaiementsOverview from "@pages/Reporting/AdyenPaiementsOverview";
import Unauthorizedaccess from "@pages/Authentication/Unauthorizedaccess";
import AdyenReportsOverview from "@pages/Reporting/AdyenReportsOverview";
import UpdatePassword from "@pages/Authentication/UpdatePassword";
import Login from "@pages/Authentication/Login";
import AuthLayout from "@components/AuthLayout";

import AuthRouter from "./middleware/AuthRouter";
import { Payments } from "@pages/AdvancedReporting/Payments";
import Facturation from "@pages/Facturations/Facturation";
import FacturationConecs from "@pages/Facturations/FacturationConecs";

export default function Router() {
    const { t } = useTranslation();

    return useRoutes([
        {
            element: (
                <AuthRouter>
                    <AuthLayout />
                </AuthRouter>
            ),
            children: [
                {
                    path: "Reporting",
                    children: [
                        {
                            path: t("Transactions"),
                            element: <AdyenTransactionsOverview />,
                        },

                        {
                            path: "/Reporting/Payout",
                            element: <AdyenPaiementsOverview />,
                        },
                        {
                            path: "/Reporting/Reports",
                            element: <AdyenReportsOverview />,
                        },
                        {
                            path: "/Reporting/AdvancedReports",
                            element: <SoftaveraTransactionsOverview />,
                        },
                        {
                            path: "/Reporting/AdvancedEcomReports",
                            element: <SoftaveraTransactionsEcomOverview />,
                        },
                        {
                            path: "/Reporting/Payments",
                            element: <Payments />,
                        },
                    ],
                },

                {
                    path: "ReportingConecs",
                    children: [
                        {
                            path: t("Paiements"),
                            element: <PaiementsConecsOverview />,
                        },
                    ],
                },

                {
                    path: "Facturation",
                    children: [
                        {
                            path: "/Facturation/Facturation",
                            element: <Facturation />,
                        },
                        {
                            path: "/Facturation/FacturationConecs",
                            element: <FacturationConecs />,
                        },
                    ],
                },

                {
                    path: "/unauthorizedaccess",
                    element: <Unauthorizedaccess />,
                },
            ],
        },

        {
            element: <Login />,
            path: "/",
        },
        { path: "/update", element: <UpdatePassword /> },
    ]);
}
